/** RPC の生メッセージで分類し、表示用プレフィックスを付けても分類を保持する。 */
export class CustomerDetailError extends Error {
  readonly kind: 'forbidden' | 'unknown';
  readonly code?: string;
  constructor(error: {message: string; code?: string}) {
    super(`顧客詳細取得エラー: ${error.message}`);
    this.name = 'CustomerDetailError';
    this.kind = error.message.startsWith('unauthorized:') || error.code === '42501' ? 'forbidden' : 'unknown';
    this.code = error.code;
  }
}
